import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName, IconType } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseBadgeElement, toBadgeProps } from '../common';
var SubTasksProgressElement = function SubTasksProgressElement(props) {
  var _context$subTasksProg;
  var context = useFlexibleUiContext();
  var data = context ? toBadgeProps((_context$subTasksProg = context.subTasksProgress) === null || _context$subTasksProg === void 0 ? void 0 : _context$subTasksProg.toString()) : null;
  return data ? /*#__PURE__*/React.createElement(BaseBadgeElement, _extends({
    icon: IconType.SubTasksProgress
  }, data, props, {
    name: ElementName.SubTasksProgress
  })) : null;
};
export default SubTasksProgressElement;